export const environment = {
    production: false,
    apiEndPoint: 'https://hvf.appmaister.com/v1/admin/'
    // apiEndPoint: 'https://dev-travelgirl.consagous.co.in/api/v1/admin/'
};